import { defaultPreviewSurfaceBackground } from "./types";

export function sanitizeCssColor(value: string | undefined) {
  if (!value) {
    return defaultPreviewSurfaceBackground;
  }

  const trimmed = value.trim();

  if (
    /^(#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})|rgba?\(\s*[\d.]+\s*(?:,\s*[\d.]+\s*){2,3}\))$/i.test(
      trimmed,
    )
  ) {
    return trimmed;
  }

  return defaultPreviewSurfaceBackground;
}

export const htmlEscapes: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(value: string) {
  return value.replace(/[&<>"']/g, (character) => htmlEscapes[character]);
}
